import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgArrowUpSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M1 8.00098L8 1.00098M8 1.00098L15 8.00098M8 1.00098V15.001"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgArrowUpSmall.displayName = 'SvgArrowUpSmall';
const ArrowUpSmall = withForgeIconProps(SvgArrowUpSmall, {
  name: 'ArrowUp',
  usage: 'Use to indicate the ability to move an item up.',
  related: 'move, direction',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default ArrowUpSmall;
